// Layout.js
import React, { useEffect, useState } from 'react';
import { Drawer, AppBar, Toolbar, List, ListItem, ListItemIcon, ListItemText, IconButton, InputBase, MenuItem, Menu, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { grey } from '@mui/material/colors';
import imageSrc from "../Icons/logo.png";
import DashboardIcon from '@mui/icons-material/Dashboard';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import { Link, useLocation } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import HandshakeIcon from '@mui/icons-material/Handshake';
import GroupsIcon from '@mui/icons-material/Groups';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { callApi } from '../../common/api.js';
import Select from 'react-select';
import "./style/Layout.css";
import Loader from '../../common/components/Loader';
import NotificationComponent from '../companyWall/NotificationComponent.js';
import Popover from '@mui/material/Popover';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import Paper from '@mui/material/Paper';
import { createDeviceToken } from '../../common/FirebaseCall.js';

const drawerWidth = 240;
const LogoWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  height: '60px',
  // Adjust the height of the logo container based on your design
}));
const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: '#212121', // Set the background color to black
  },
  // Add any other custom styles for the drawer content here
}));
const Sidebar = () => {
  const classes = useStyles();
  const ListItemWrapper = styled(ListItem)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '5px ',
    '&:hover': {
      backgroundColor: 'black',
      width: 'calc(100% - 25px)', // 20px is the total gap on both sides (10px on each side)
      margin: '0 10px', // 10px gap on both sides
    },
  }));
  const [number, setNumber] = useState(0)
  const location = useLocation();
  useEffect(() => {
    const pathArray = ['', '/startup', '', '/ongoingDeals', '/meetings', '/profile']
    const pathname = location.pathname;
    const num = pathArray.indexOf(pathname)
    setNumber(num + 1)
  }, [])

  const changeColor = (number) => {
    setNumber(number)
  }

  const [state, setState] = React.useState(false)
  const handleMenuClick = () => {
    setState(!state)
  }
  return (
    <Drawer className={classes.drawer}
      variant="permanent"
      sx={{

        '& .MuiDrawer-paper': {
          display: "flex",
          flexDirection: "column",
          gap: "50px", backgroundColor: "#212121", boxSizing: 'border-box', width: drawerWidth
        },
      }}
    >

      <LogoWrapper>
        {/* Add your logo here */}
        <img src={imageSrc} alt="Logo" />
      </LogoWrapper>
      <List sx={{ display: 'flex', flexDirection: 'column', gap: '5px', paddingLeft: '30px' }}>
        {/* Define your sidebar items here */}
        <ListItemWrapper button={true} component={Link} to="/dashboard" onClick={() => changeColor(1)} sx={{ backgroundColor: number === 1 ? "#121212" : '', '&:hover': { backgroundColor: 'gray' } }}>
          <ListItemIcon>
            <DashboardIcon sx={{ color: "white" }} />
          </ListItemIcon>
          <ListItemText primary="Dashboard" sx={{ color: "white" }} />
        </ListItemWrapper>

        <ListItemWrapper button={true} component={Link} to="/startup" onClick={() => changeColor(2)} sx={{ backgroundColor: number === 2 ? "#121212" : '', '&:hover': { backgroundColor: 'gray' } }}>
          <ListItemIcon>
            <PersonSearchIcon sx={{ color: "white" }} />
          </ListItemIcon>
          <ListItemText primary="Approval" sx={{ color: "white" }} />
        </ListItemWrapper>

        <ListItemWrapper button={true} component={Link} to="" onClick={() => changeColor(3)} sx={{ backgroundColor: number === 3 ? "#121212" : '', '&:hover': { backgroundColor: 'gray' } }}>
          <ListItemIcon>
            <AccountBalanceIcon sx={{ color: "white" }} />
          </ListItemIcon>
          <ListItemText primary="Social" sx={{ color: "white" }} />
          <ArrowDropDownIcon sx={{ color: "white" }} onClick={handleMenuClick} />
        </ListItemWrapper>

        {state ?
          <>
            <ListItemWrapper button={true} component={Link} to="" onClick={() => changeColor(3)}>
              <ListItemText primary="Company Feed" sx={{ color: "white", paddingLeft: "50px" }} />
            </ListItemWrapper>

            <ListItemWrapper button={true} component={Link} to="/AllNotifications" onClick={() => changeColor(3)}>
              <ListItemText primary="Draft" sx={{ color: "white", paddingLeft: "50px" }} />
            </ListItemWrapper>
          </>
          : <></>}

        <ListItemWrapper button={true} component={Link} to="/ongoingDeals" onClick={() => changeColor(4)} sx={{ backgroundColor: number === 4 ? "#121212" : '', '&:hover': { backgroundColor: 'gray' } }}>
          <ListItemIcon>
            <HandshakeIcon sx={{ color: "white" }} />
          </ListItemIcon>
          <ListItemText primary="Ongoing Deals" sx={{ color: "white" }} />
        </ListItemWrapper>

        <ListItemWrapper button={true} component={Link} to="/meetings" onClick={() => changeColor(5)} sx={{ backgroundColor: number === 5 ? "#121212" : '', '&:hover': { backgroundColor: 'gray' } }}>
          <ListItemIcon>
            <GroupsIcon sx={{ color: "white" }} />
          </ListItemIcon>
          <ListItemText primary="Meetings" sx={{ color: "white" }} />
        </ListItemWrapper>

        <ListItemWrapper button={true} component={Link} to="/profile" onClick={() => changeColor(6)} sx={{ backgroundColor: number === 6 ? "#121212" : '', '&:hover': { backgroundColor: 'gray' } }}>
          <ListItemIcon>
            <ManageAccountsIcon sx={{ color: "white" }} />
          </ListItemIcon>
          <ListItemText primary="Settings" sx={{ color: "white" }} />
        </ListItemWrapper>
        {/* Add more sidebar items as needed */}
      </List>
    </Drawer>
  );
};



const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: 'transparent', // Set the background color to transparent
  border: '1px solid #343333',
  borderRadius: "10px", // Add a border to the search bar
  width: 280, // Set the fixed length of the search bar (adjust this value as needed)
  marginLeft: 0,
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
  },
}));
const Spacer = styled('div')({
  flexGrow: 1,
});
const NavigationBar = ({ docSubmit }) => {
  const useStyles = makeStyles((theme) => ({
    customIcon: {
      color: 'grey', // Replace this with your desired color
    },
  }));
  const [anchorSn, setAnchorSn] = React.useState(null)
  const [deal, setDeal] = React.useState([])
  const [pic, setPic] = React.useState("")
  const [selectedOption, setSelectedOption] = React.useState(null);
  const [success, setSuccess] = useState(false)
  const openSignup = Boolean(anchorSn);
  const classes = useStyles();

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#212121",
      border: "1px #575555 solid",
      borderRadius: "8px",
      color: "#fff",
      fontSize: "14px",
      height: "40px",
      width: "385px",
      marginLeft: "20px"
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "grey",
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: 'none', // Remove the indicator separator
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#212121",
      width: "385px",
      marginLeft: "20px",
      border: "2px solid #666666",
      borderRadius: "8px",
      paddingLeft: '5px',
      color: "white",
      // Change the background color of the options window to black
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? 'black' : '#212121', // Background color of selected options
      color: state.isSelected ? 'white' : 'white', // Text color of selected options
      borderRadius: '8px',
      '&:hover': {
        backgroundColor: 'grey',
        borderRadius: '8px',
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#fff", // Set the text color of the selected option to white
    })
  };

  // const customOptionStyles = {
  //   option: (provided, state) => ({
  //     ...provided,
  //     backgroundColor: state.isSelected ? 'black' : 'white', // Background color of selected options
  //     color: state.isSelected ? 'white' : 'black', // Text color of selected options
  //   }),
  // };

  const handleLogOutOpen = (event) => {
    setAnchorSn(event.currentTarget);
  }
  const handleSignupClose = () => {
    setAnchorSn(null);
  };

  const handleLinkClick = async () => {
    // const firebaseToken = await createDeviceToken();
    let token = JSON.parse(localStorage.getItem("accessToken"))
    let obj = {
       accessToken : token
    }
    const response = await callApi("post", "auth/logout", obj)
    localStorage.clear();
    // const firbaseResponse = await callApi('post',`admin/deleteDeviceToken?deviceToken=${firebaseToken}`)
    window.location.href = `${process.env.REACT_APP_LANDING_PAGE_URL}?logout=true`

  }

  const options = deal.map((option) => ({
    value: option.dealName,
    label: option.dealName,
  }));


  const getDeal = async () => {
    try {
      const rowData = await callApi("get", "startup/allStartupDeals");
      const data = rowData?.data?.response?.data?.response;
      setDeal(data)
    } catch (err) {
      console.log(err)
    }
  }
  const [user, setUser] = React.useState({})
  const getProfile = async () => {
    try {
      const details = await callApi("get", "userRegister")
      setUser(details?.data?.response?.data)
    } catch (error) {
      console.log(error)
    }
  }
  React.useEffect(() => {
    getDeal()
    getProfile()
    getPhoto()
  }, [])

  const getPhoto = async () => {
    try {
      const response = await callApi("get", "userRegister/userProfile")
      const photo = response?.data?.response?.data?.userDocuments[0]?.link
      setPic(photo)
      const status = response.data.response.status
      setSuccess(status)
    } catch (err) {
      console.log(err)
    }
  }

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleNotificationClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const array = ["Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it "]

  return (
    <>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Paper
          style={{
            backgroundColor: 'black',
            borderRadius: '8px',
            width: '500px',
            padding: '16px',
            overflow: 'auto',
            maxHeight: '500px',
          }}
        >
          <NotificationComponent array={array} />
        </Paper>
      </Popover>

      <AppBar style={{ left: docSubmit ? "8.5%" : "14.5%" }} sx={{ backgroundColor: 'black', maxWidth: "83.1%" }}>
        <Toolbar sx={{ padding: "0 !important" }}>
          {docSubmit ?
            <LogoWrapper>
              <img src={imageSrc} alt="Logo" />
            </LogoWrapper>
            : <></>
          }

          {/* Left corner: Search Bar */}
          {docSubmit ?
            <></>
            :
            <>
              <Search sx={{ marginLeft: "4% !important", width: "385px !important", backgroundColor: "#212121", border: "1px #575555 solid" }}>
                <SearchIconWrapper>
                  <SearchIcon style={{ color: grey[500] }} />
                </SearchIconWrapper>
                <StyledInputBase placeholder="Search" inputProps={{ 'aria-label': 'search' }} />
              </Search>

              <Select
                id="deal"
                name="deal"
                placeholder='Select your Deal'
                value={selectedOption}
                onChange={(selected) => setSelectedOption(selected)}
                styles={{ ...customStyles }}
                options={options}
                isSearchable={false}
              />
            </>
          }
          {/* Center: App Name */}
          <Spacer />
          {/* Right corner: Bell Icon and Profile Logo */}
          {/* <IconButton color="inherit">
            <NotificationsNoneIcon onClick={handleNotificationClick} />
          </IconButton> */}
          <IconButton color="inherit">
            {success ? <Link to={`/profile`}><div><img src={pic} style={{ alignItems: 'center', marginRight: '5px', width: '40px', height: '40px', borderRadius: '20px' }} /></div></Link> : <div style={{ marginRight: "40px", width: '2% ', height: '2%', position: 'relative' }}><Loader className="loading" style={{ marginRight: "40px", width: '2%', height: '2%', position: 'relative' }} /></div>}
            <Link style={{ textDecoration: 'none', color: 'white', fontSize: '15px', fontWeight: '200', marginRight: '5px' }} to={`/profile`} color="inherit">
              {user?.firstName}
            </Link>
            <Link style={{ textDecoration: 'none', color: 'white', fontSize: '15px', fontWeight: '200', marginRight: '5px' }} to={`/profile`} color="inherit">
              {user?.lastName}
            </Link>
            <KeyboardArrowDownIcon onClick={handleLogOutOpen} />
            <Menu
              className='logout-menu'
              anchorEl={anchorSn}
              open={openSignup}
              onClose={handleSignupClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <MenuItem onClick={handleSignupClose} style={{ padding: "0 !important", padding: "unset" }} sx={{ backgroundColor: "white", color: "black", "&:hover": { backgroundColor: "#212121", color: "white" } }}>
                {/* <Button style={{ textDecoration: 'none', color: 'black',alignSelf:"stretch",fontSize:"17px" }} to={`/login`} onClick={() => { handleLinkClick() }} color="inherit">
                  Log out
                </Button> */}
                <Button id="hawadagallo" onClick={handleLinkClick} className="hoverBtn" sx={{ backgroundColor: "white", color: "black", "&:hover": { backgroundColor: "#212121", color: "white", width: "100%" } }}>Log out</Button>
              </MenuItem>
            </Menu>
          </IconButton>
        </Toolbar>
      </AppBar>
    </>
  );
};


const useStyle = makeStyles((theme) => ({
  // ... other styles
  layoutContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // Align children horizontally in the center
    paddingTop: '60px', // Add top padding to center the content vertically
    paddingLeft: '230px',
    maxHeight: "100%",
    position: 'relative'
  },
}));

const LayoutOld = ({ children, docSubmit }) => {
  const classes = useStyle();

  return (
    <div style={{ paddingLeft: docSubmit ? "0" : "230px" }} className={classes.layoutContainer}>
      {!docSubmit ? <Sidebar /> : <></>}
      <div style={{ width: docSubmit ? "65%" : "100%", height: docSubmit ? "0" : "100vh" }}>
        <NavigationBar docSubmit={docSubmit} />
        {children}
      </div>
    </div>
  );
};



export default LayoutOld;
